import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {DragDropContext, Draggable, Droppable} from "@hello-pangea/dnd";

import ArmyListUnitComponent from '../make/ArmyListUnitComponent';
import {container} from "@Container";
import {ArmyListUnitAction} from "@Redux/actions";
import {TYPES} from "@Types";
import {armyListUnits} from "@Selectors/builder/myArmyList/minimal/armyListUnits";

const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",

  // change background colour if dragging
  background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = (isDraggingOver: boolean) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey"
});

const ArmyListUnitSection: React.FC<ArmyListUnitSectionProps> = ({
                                                                   armyListUnits,
                                                                   onDragEnd
                                                                 }) => {

  return (
    <section className="mb-2">
      <div className="army_list_units_overview ui-sortable ms-3">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided: any, snapshot: any) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {armyListUnits.map((item) => (
                  <Draggable key={`army-list-unit-${item.id}`} draggableId={`${item.id}`} index={item.position}>
                    {(provided: any, snapshot: any) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <ArmyListUnitComponent armyListUnit={item} showOrganisation={true} />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  armyListUnits: armyListUnits(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArmyListUnitAction>(TYPES.Actions.ArmyListUnitAction);
  return {
    onDragEnd: (result: any) => dispatch(armyListUnitAction.moveArmyListUnit({
      armyListUnitId: result.draggableId,
      source: result.source.index,
      destination: result.destination.index
    })),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitSection);

type ArmyListUnitSectionProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
